@if (order) {
  @if (forbiddenEdit()) {
    @if (order.status.id == OrderStatus.Submitted) {
      <div class="flex center padding bg-orange">
        <i class="fa fa-circle-info margin-right-smallest"></i>
        @if (order.isFake) {
          Order is submitted. Set it as ready for pickup when the products are available at BasicNet. Data editing is
          not available.
        } @else {
          Order is submitted. Waiting for package and shipping label. Data editing is not available.
        }
      </div>
    } @else if (order.status.id == OrderStatus.ReadyForPickup) {
      <div class="padding bg-orange flex center">
        <i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
        Order is ready for pickup. Waiting for photographer shots. Data editing is not available.
      </div>
    } @else if (order.status.id == OrderStatus.ShootCompleted) {
      <div class="padding bg-orange flex center">
        <i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
        Some shots are waiting for approval. Please review and approve or reject them.
      </div>
    } @else if (order.status.id == OrderStatus.Rejected) {
      <div class="padding bg-orange flex center">
        <i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
        Order is rejected. Waiting for photographer to fix photos. Data editing is not available.
      </div>
    } @else if (order.status.id == OrderStatus.InProgress) {
      <div class="padding bg-orange flex center">
        <i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
        Order is in progress. Data editing is not available.
      </div>
    } @else if (order.status.id == OrderStatus.Approved) {
      <div class="padding bg-green white flex center">
        <i class="fa-solid fa-circle-check margin-right-smallest"></i>
        Order is approved. Data editing is not available.
      </div>
    }
  }

  <div class="padding-large m-padding">
    <div class="page-layout">
      <bt-page-header title="Order details" subtitle="Products, colors and shots of the order" icon="fa-solid fa-dolly">

        <div class="flex center m-full-width m-margin-top">
          @if (!forbiddenEdit()) {
            <button class="m-flex-1" (click)="addProductModal()">
              <i class="fa fa-add"></i>
              Add
              <span class="desktop-only margin-left-smallest">products</span>
            </button>
          }

          @if (order.status.id == OrderStatus.Draft) {
            <!-- @if (somethingChanged()) {
							<button (click)="saveChanges()" class="m-flex-1 margin-left-small">
								<i class="fa-solid fa-save margin-right-smallest"></i>
								Save Changes
							</button>
						} @else {
							@if (!noProducts()) {
								<button (click)="submitOrder()" class="m-flex-1 bg-green white margin-left-small">
									<i class="fa-solid fa-paper-plane margin-right-smallest"></i>
									Send to photographer
								</button>
							}
							}-->

            @if (!noProducts()) {
              <button (click)="submitOrder()" class="m-flex-1 bg-green white margin-left-small">
                <i class="fa-solid fa-paper-plane margin-right-smallest"></i>
                Confirm order
              </button>
            }
          } @else if (order.status.id == OrderStatus.Submitted) {
            <button (click)="setAsReadyForPickup()" class="m-flex-1 bg-primary-dark white margin-left-small">
              <i class="fa-solid fa-paper-plane margin-right-smallest"></i>
              Set as ready for pickup
            </button>
          } @else if (order.status.id == OrderStatus.ShootCompleted) {
            @if (orderDetails.items.length > 0) {
              @if (!allShotsAre(ShotApprovalStatus.Approved)) {
                <button
                  class="bg-green white m-flex-1 margin-left-small"
                  (click)="approveAllShots(ShotApprovalStatus.Approved)"
                >
                  <i class="fa fa-check"></i>
                  Approve all
                </button>
              }
              @if (!allShotsAre(ShotApprovalStatus.Rejected)) {
                <button
                  class="bg-red white m-flex-1 margin-left-small"
                  (click)="approveAllShots(ShotApprovalStatus.Rejected)"
                >
                  <i class="fa fa-undo"></i>
                  Reject all
                </button>
              }

              @if (someShotsAre(ShotApprovalStatus.Rejected)) {
                <button
                  class="bg-primary white m-flex-1 margin-left-small"
                  (click)="sendToPhotographer(OrderStatus.Rejected)"
                >
                  <i class="fa-solid fa-share"></i>
                  Send back to photographer
                </button>
              }

              @if (someShotsAre(ShotApprovalStatus.Approved)) {
                <button
                  class="bg-primary white m-flex-1 margin-left-small"
                  (click)="sendToPhotographer(OrderStatus.Approved)"
                >
                  <i class="fa fa-check"></i>
                  Confirm order
                </button>
              }
            }
          }
        </div>
      </bt-page-header>

      @if (orderDetails.items.length > 0) {
        <div class="flex center gap more margin-top-small">
          @if (order.isFake) {
            <div class="flex column start">
              <div>Pickup location:</div>
              <div
                class="flex border column padding-smallest padding-right-small padding-left-small radius margin-top-small"
              >
                <b>BasicNet</b>
                <span class="grey">Largo Maurizio Vitale, Torino</span>
              </div>
            </div>
          } @else if (currentWarehouse) {
            <div class="flex column start">
              <div>Warehouse:</div>
              <div
                class="flex border column padding-smallest padding-right-small padding-left-small radius margin-top-small"
              >
                <b>{{ currentWarehouse.description || '-' }}</b>
                <span class="grey">{{ currentWarehouse.address || '-' }}</span>
              </div>
            </div>
          }

          <div class="flex column start">
            <div>SKUs:</div>
            <div
              class="flex border bg-light-blue sku-count column center justify-center padding-smallest padding-right-small padding-left-small radius margin-top-small"
            >
              <h3>{{ shotResume.totalSku }}</h3>
            </div>
          </div>

          <div class="flex column start">
            <div class="flex center between full-width">
              Total cost:

              <span
                class="primary flex center hover {{ isApproved() ? 'disabled' : '' }}"
                (click)="openSetFinalCostModal()"
              >
                <i class="fa fa-edit margin-right-smallest"></i>
                Edit
              </span>
            </div>
            <div
              class="flex padding-smallest {{
                shotResume.finalCost ? 'bg-light-blue' : 'bg-orange'
              }} padding-left-small radius padding-right-small column margin-top-small"
            >
              @if (shotResume.finalCost) {
                <b class="primary-dark">
                  {{ shotResume.finalCost ? (shotResume.finalCost | currency: 'EUR' : 'symbol' : '1.2-2') : '-' }}
                </b>
                <span>
                  {{ shotResume.finalCost / shotResume.totalSku | currency: 'EUR' : 'symbol' : '1.2-2' }} per SKU
                </span>
              } @else {
                <b class="red">0,00€</b>
                <span class="red">Please add a total cost</span>
              }
            </div>
          </div>
        </div>

        <div class="flex end between margin-top-small desktop-only">
          <div class="flex end">
            <span class="grey margin-right-small">Actions:</span>

            @if (thereAreImages()) {
              @if (
                order.status.id == OrderStatus.ShootCompleted ||
                order.status.id == OrderStatus.Approved ||
                order.status.id == OrderStatus.Rejected
              ) {
                <span class="hover primary {{ someShotsAreUploaded() ? '' : 'disabled' }}" (click)="downloadAllShots()">
                  <i class="fa fa-download margin-right-smallest"></i>
                  Download images as Zip
                </span>
              }
            }

            <!-- @if (order.status.id == OrderStatus.Submitted || order.status.id == OrderStatus.InProgress) {
						<span class="hover red disabled">
							<i class="fa-solid fa-rotate-left margin-right-smallest"></i>
							Cancel submission
						</span>
					} -->
          </div>

          <div class="flex center">
            <bt-paginator
              [pageNumber]="orderDetails.currentPage"
              [pageSize]="orderDetails.size"
              [totalNumber]="orderDetails.totalCount"
              (clickPage)="pageEvent($event)"
            ></bt-paginator>
          </div>
        </div>
      }

      <!-- inizio lista prodotti -->
      @for (product of orderDetails.items; track product; let h = $index) {
        <div class="flex column margin-top-small border radius">
          <div class="flex center between bg-light-grey padding-small radius radius-bottom-none">
            <div class="flex center">
              <div class="flex column">
                <b class="primary-dark">
                  {{ product.style.brand.name }} - {{ product.style.code }} - {{ product.style.name }} -
                  {{ product.style.gender?.name }}
                </b>
                <span class="small grey">
                  {{ product.style.category.name }}
                  {{ product.style.collection?.name ? ' - ' + product.style.collection?.name : '' }}
                </span>
              </div>

              @if (!product.opened) {
                <span class="margin-left">
                  @for (color of product.colorShots.slice(0, 5); track color.color.id; let last = $last) {
                    {{ color.color.code }} {{ color.color.name }}
                    @if (!last) {
                      ,
                    }
                  }

                  @if (product.colorShots.length > 5) {
                    <span class="grey margin-left-smallest">+ {{ product.colorShots.length - 5 }} others</span>
                  }
                </span>
              }
            </div>

            <div class="flex center">
              @if (
                order.status.id == OrderStatus.ShootCompleted ||
                order.status.id == OrderStatus.Approved ||
                order.status.id == OrderStatus.Rejected
              ) {
                @if (getShotsByProduct(product).length > 0) {
                  @if (
                    getShotsByProduct(product, ShotApprovalStatus.Approved).length == getShotsByProduct(product).length
                  ) {
                    <span class="margin-right-small desktop-only green bold radius padding-smallest">
                      All shots approved
                    </span>
                  } @else if (
                    getShotsByProduct(product, ShotApprovalStatus.Rejected).length == getShotsByProduct(product).length
                  ) {
                    <span class="margin-right-small desktop-only red bold radius padding-smallest">
                      All shots rejected
                    </span>
                  } @else {
                    @if (getShotsByProduct(product, ShotApprovalStatus.Approved).length > 0) {
                      <span class="margin-right-small desktop-only green bold padding-smallest">
                        {{ getShotsByProduct(product, ShotApprovalStatus.Approved).length }} approved
                      </span>
                    }
                    @if (getShotsByProduct(product, ShotApprovalStatus.Rejected).length > 0) {
                      <span class="margin-right-small desktop-only red bold padding-smallest">
                        {{ getShotsByProduct(product, ShotApprovalStatus.Rejected).length }} rejected
                      </span>
                    }

                    @if (order.status.id != OrderStatus.Approved) {
                      @if (getShotsByProduct(product, ShotApprovalStatus.Uploaded).length > 0) {
                        <span class="margin-right-small desktop-only orange bold padding-smallest">
                          {{ getShotsByProduct(product, ShotApprovalStatus.Uploaded).length }} waiting for approval
                        </span>
                      }
                    }
                  }

                  @if (
                    getShotsByProduct(product, ShotApprovalStatus.NotUploaded).length ==
                    getShotsByProduct(product).length
                  ) {
                    <span class="margin-right-small desktop-only grey bold padding-smallest">No Action required</span>
                  }
                } @else {
                  <span class="margin-right-small desktop-only grey padding-smallest">No required actions</span>
                }
              }

              @if (order.status.id == OrderStatus.InProgress) {
                @if (getShotsByProduct(product, ShotApprovalStatus.Approved).length > 0) {
                  <span class="margin-right-small desktop-only green bold padding-smallest">
                    {{ getShotsByProduct(product, ShotApprovalStatus.Approved).length }} approved
                  </span>
                }
                @if (getShotsByProduct(product, ShotApprovalStatus.Rejected).length > 0) {
                  <span class="margin-right-small desktop-only red bold padding-smallest">
                    {{ getShotsByProduct(product, ShotApprovalStatus.Rejected).length }} rejected
                  </span>
                }

                <span class="margin-right-small desktop-only orange bold padding-smallest">
                  {{ getShotsByProduct(product, ShotApprovalStatus.NotUploaded).length }} waiting for upload
                </span>
              }

              @if (order.status.id == OrderStatus.ReadyForPickup) {
                <span class="margin-right-small desktop-only orange bold padding-smallest">
                  Waiting for photographer shots
                </span>
              }

              @if (!forbiddenEdit()) {
                <div class="flex center red hover desktop-only margin-right" (click)="removeProduct(product)">
                  <i class="fa-solid fa-xmark margin-right-small"></i>
                  Remove product
                </div>
              }

              <i
                class="fa-solid {{ product.opened ? 'fa-chevron-up' : 'fa-chevron-down' }} hover"
                (click)="toggle(product)"
              ></i>
            </div>
          </div>

          @if (product.opened) {
            @for (color of product.colorShots; track color; let g = $index) {
              <div class="padding">
                <div class="between flex center m-column m-start">
                  <div class="flex center">
                    <div class="flex center margin-right-small">
                      @if (color.colorDraftImage) {
                        <img
                          class="color-draft hover"
                          [src]="color.colorDraftImage"
                          (click)="viewColorDraftImage(color)"
                        />
                      } @else {
                        <div class="color-draft color-draft-empty flex center justify-center">
                          <i class="grey fa fa-image"></i>
                        </div>
                      }
                    </div>

                    <div class="flex center">
                      <span
                        class="bg-light-grey border primary bold padding-left-smallest padding-right-smallest radius"
                      >
                        {{ color.color.code }} {{ color.color.name || '-' }}
                      </span>
                    </div>

                    <div class="flex center margin-left">
                      <b>Size:</b>
                      @if (forbiddenEdit() || order.isFake) {
                        <span class="margin-left-smallest">
                          {{ color.color.size.name }}
                        </span>
                      } @else {
                        <span
                          class="margin-left-smallest primary hover"
                          (click)="openManageColorsSizesModal(product, color.color)"
                        >
                          {{ color.color.size.name }}
                          <i class="fa fa-edit margin-left-smallest"></i>
                        </span>
                      }
                    </div>

                    <!-- <div class="radius padding-left-smallest padding-right-smallest flex center margin-left">
											<b>Cost:</b>
											<span class="margin-left-smallest">
												{{ color.color.estimatedCost ? (color.color.estimatedCost | currency: 'EUR' : 'symbol' : '1.2-2') : '-' }}
											</span>
										</div > -->
                  </div>

                  <div class="flex center m-full-width m-margin-top-small">
                    @if (color.isAi) {
                      @if (!forbiddenEdit()) {
                        <div
                          (click)="setAiGenerated(color)"
                          class="flex hover center bg-orange primary padding-left-smallest padding-right-smallest border radius margin-right"
                        >
                          <i class="fa-solid fa-robot margin-right-smallest"></i>
                          AI generated
                        </div>
                      } @else {
                        <div
                          class="flex center bg-orange primary padding-left-smallest padding-right-smallest border radius margin-right"
                        >
                          <i class="fa-solid fa-robot margin-right-smallest"></i>
                          AI generated
                        </div>
                      }
                    } @else {
                      @if (!forbiddenEdit()) {
                        <div
                          class="flex center primary hover desktop-only margin-right"
                          (click)="setAiGenerated(color)"
                        >
                          <i class="fa-solid fa-robot margin-right-small"></i>
                          Set as AI generated
                        </div>
                      }
                    }

                    @if (order.status.id != OrderStatus.InProgress) {
                      <div
                        class="flex center primary hover desktop-only margin-right {{
                          getShotsWithImages(color).length ? '' : 'disabled'
                        }} "
                        (click)="viewGallery(getShotsWithImages(color))"
                      >
                        <i class="fa-solid fa-expand margin-right-small"></i>
                        View as gallery
                      </div>
                    }

                    @if (order.status.id == OrderStatus.Draft) {
                      <div class="flex center red hover desktop-only" (click)="removeColor(product, color.color)">
                        <i class="fa-solid fa-xmark margin-right-small"></i>
                        Remove color
                      </div>
                    }

                    @if (order.status.id == OrderStatus.ShootCompleted) {
                      <div
                        class="flex center primary hover margin-left desktop-only {{
                          getShotsWithImages(color).length ? '' : 'disabled'
                        }}"
                        (click)="downloadShots(getShotIdsByColor(color))"
                      >
                        <i class="fa-solid fa-download margin-right-small"></i>
                        Download images
                      </div>

                      <button
                        class="bg-red mini white margin-left m-margin-none m-flex-1 {{
                          getShotsWithImages(color).length ? '' : 'disabled'
                        }}"
                        (click)="approveShots(getShotIdsByColor(color), ShotApprovalStatus.Rejected)"
                      >
                        <i class="fa fa-undo"></i>
                        Reject color
                      </button>
                      <button
                        class="bg-green mini white margin-left-small m-margin-none m-margin-left m-flex-1 {{
                          getShotsWithImages(color).length ? '' : 'disabled'
                        }}"
                        (click)="approveShots(getShotIdsByColor(color), ShotApprovalStatus.Approved)"
                      >
                        <i class="fa fa-check"></i>
                        Approve color
                      </button>
                    }

                    @if (order.status.id == OrderStatus.Approved || order.status.id == OrderStatus.Rejected) {
                      <div
                        class="flex center primary hover desktop-only {{
                          getShotsWithImages(color).length ? '' : 'disabled'
                        }}"
                        (click)="downloadShots(getShotIdsByColor(color))"
                      >
                        <i class="fa-solid fa-download margin-right-small"></i>
                        Download images
                      </div>
                    }
                  </div>
                </div>

                <div class="shot-grid margin-top">
                  @for (shot of color.shots; track shot; let f = $index) {
                    <div
                      class="padding-small flex column   border border-grey radius between {{
                        shot.shotApprovalStatus == ShotApprovalStatus.Approved
                          ? 'bg-light-green border-green'
                          : shot.shotApprovalStatus == ShotApprovalStatus.Rejected
                            ? 'bg-light-red border-red'
                            : 'bg-white'
                      }}"
                    >
                      <div class="flex">
                        <div class="flex-0 margin-right-small">
                          @if (
                            order.status.id == OrderStatus.InProgress &&
                            shot.shotApprovalStatus != ShotApprovalStatus.Approved
                          ) {
                            <div class="placeholder flex center justify-center">
                              <i class="grey fa fa-clock fa-lg"></i>
                            </div>
                          } @else {
                            @if (shot.imgPath) {
                              <div class="placeholder shot-image-wrapper">
                                @if (isShotImageLoading(shot)) {
                                  <div class="shot-image-loader flex center justify-center">
                                    <i class="fa-solid fa-spinner fa-spin"></i>
                                  </div>
                                }

                                @if (isVideo(shot)) {
                                  <img
                                    class="shot-image hover"
                                    (click)="viewGallery(getShotsWithImages(color), shot.id)"
                                    [class.shot-image-hidden]="isShotImageLoading(shot)"
                                    alt="Shot preview"
                                    (load)="onShotImageLoad(shot)"
                                    (error)="onShotImageError(shot)"
                                  />
                                  <i class="fa-solid fa-circle-play video-play-icon"></i>
                                } @else {
                                  <img
                                    class="shot-image hover"
                                    (click)="viewGallery(getShotsWithImages(color), shot.id)"
                                    [class.shot-image-hidden]="isShotImageLoading(shot)"
                                    [src]="shot.imgPath"
                                    alt="Shot preview"
                                    (load)="onShotImageLoad(shot)"
                                    (error)="onShotImageError(shot)"
                                  />
                                }
                              </div>
                            } @else {
                              <div class="placeholder flex center justify-center"><i class="grey fa fa-image"></i></div>
                            }
                          }
                        </div>
                        <div class="flex-1 flex column">
                          <div class="flex center between">
                            <div class="flex center">
                              <b>
                                @if (shot.isAi) {
                                  <i
                                    class="fa-solid fa-robot primary margin-right-smallest"
                                    matTooltip="AI generated"
                                  ></i>
                                }
                                {{ shot.shotType.name }}
                              </b>

                              @if (shot.mandatory) {
                                <small
                                  class="primary margin-left-smallest flex center padding-smallest"
                                  matTooltip="Mandatory"
                                >
                                  <i class="fa-solid fa-lock margin-right-smallest"></i>
                                </small>
                              }
                            </div>

                            @if (order.status.id == OrderStatus.Draft) {
                              <i class="fa fa-xmark grey hover" (click)="removeShot(color, shot)"></i>
                            }
                          </div>

                          <div class="flex column small">
                            <div class="flex between">
                              <div class="flex column">
                                <div class="grey">
                                  {{ shot.aspectRatio.id == 1 ? 'Square' : '-' }} {{ shot.aspectRatio.label }},
                                  {{ shot.mediaFormat.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="flex center between">
                        <div></div>
                        @if (order.status.id != OrderStatus.Draft) {
                          <div class="flex center">
                            @if (order.status.id == OrderStatus.ShootCompleted) {
                              @if (shot.shotApprovalStatus == ShotApprovalStatus.Approved) {
                                <div
                                  class="flex center small margin-right-small hover grey"
                                  (click)="approveShots([shot.id], ShotApprovalStatus.Uploaded)"
                                >
                                  <i class="fa fa-undo margin-right-smallest"></i>
                                  Undo
                                </div>

                                <div class="padding-smallest bg-green white flex center radius">Approved</div>
                              } @else if (shot.shotApprovalStatus == ShotApprovalStatus.Rejected) {
                                <div
                                  class="flex center small margin-right-small hover grey"
                                  (click)="approveShots([shot.id], ShotApprovalStatus.Uploaded)"
                                >
                                  <i class="fa fa-undo margin-right-smallest"></i>
                                  Undo
                                </div>
                                <div class="padding-smallest bg-red white flex center radius">Rejected</div>
                              } @else if (shot.shotApprovalStatus == ShotApprovalStatus.Uploaded) {
                                <div
                                  class="flex center red margin-left hover margin-top-small"
                                  (click)="approveShots([shot.id], ShotApprovalStatus.Rejected)"
                                >
                                  <i class="fa fa-undo margin-right-smallest"></i>
                                  Reject
                                </div>

                                <div
                                  class="flex center green margin-left hover margin-top-small"
                                  (click)="approveShots([shot.id], ShotApprovalStatus.Approved)"
                                >
                                  <i class="fa fa-check margin-right-smallest"></i>
                                  Approve
                                </div>
                              }
                            } @else if (
                              order.status.id == OrderStatus.Rejected ||
                              order.status.id == OrderStatus.InProgress ||
                              order.status.id == OrderStatus.Submitted ||
                              order.status.id == OrderStatus.Approved
                            ) {
                              @if (shot.shotApprovalStatus == ShotApprovalStatus.Rejected) {
                                <div class="padding-smallest bg-red white flex center radius margin-top-small">
                                  Rejected
                                </div>
                              } @else if (shot.shotApprovalStatus == ShotApprovalStatus.Approved) {
                                <div class="padding-smallest bg-green white flex center radius margin-top-small">
                                  Approved
                                </div>
                              } @else {
                                @if (
                                  order.status.id == OrderStatus.Rejected || order.status.id == OrderStatus.Approved
                                ) {
                                  <div class="padding-smallest bg-light-grey grey flex center radius margin-top-small">
                                    Unused
                                  </div>
                                }
                              }
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }

                  <!-- Ordini importati dal vecchio BasicStudios: immagine di catalogo di Basic.net, solo da vedere -->
                  @if (color.catalogImgPath && !color.shots?.length) {
                    <span class="grey">No images available.</span>
                  }

                  @if (order.status.id == OrderStatus.Draft) {
                    <div
                      class="add hover padding-small flex column border dashed radius between"
                      (click)="openAddShotModal(color)"
                    >
                      <div class="flex center">
                        <div class="flex-0 margin-right-small">
                          <div class="placeholder flex center justify-center">
                            <i class="primary fa fa-plus fa-lg"></i>
                          </div>
                        </div>
                        <div class="flex-1 flex column">
                          <div class="flex center between primary bold">Add shot</div>
                          <span class="grey">Select shot type</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          }
        </div>
      } @empty {
        <div class="bg-light-grey padding-largest margin-top flex column center">
          @if (!loading) {
            <i class="fa-solid fa-search fa-2xl margin-bottom grey"></i>
            <span>No products in this order</span>
            <button class="margin-top-small {{ forbiddenEdit() ? 'disabled' : '' }}" (click)="addProductModal()">
              <i class="fa-solid fa-plus"></i>
              Add products
            </button>
          }
        </div>
      }

      <bt-paginator
        [pageNumber]="orderDetails.currentPage"
        [pageSize]="orderDetails.size"
        [totalNumber]="orderDetails.totalCount"
        (clickPage)="pageEvent($event)"
      ></bt-paginator>
    </div>
  </div>
}

@if (loading) {
  <bt-loader></bt-loader>
}
